import Product from "./Product";

export default function Etudiant({ product }){

    return product &&

        <Product product={product}>

            <div className="apply-option-title">
                <span>Tarif étudiant</span>
            </div>

            <div className="apply-option-row">
                <span>Tarif préférentiel</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>Accès immédiat</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>Nécessite un justificatif étudiant</span>
            </div>
            
        </Product>
}